import * as React from "react";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import QRCode from "react-qr-code";
import { Button, ButtonGroup, Input, Snackbar, Alert } from "@mui/material";
import Icn from "./Icn";
import IconBtn from "./IconBtn";
import { colors } from "../maps/colors";
import Tx from "./Tx";
import { api } from "../maps/data.js";
import { useEffect, useState } from "react";
import InstallerAddSensorsToEdgeDialog from "./dialogs/InstallerAddSensorsToEdgeDialog";
import useZibi from "../zibi/UseZibi";
import SensorStatus from "./SensorStatus";
import Tooltip from "@mui/material/Tooltip"; // Import Tooltip

export default function InstallerShelfCard(props) {
  const { edgeId, siteId } = props;

  const [sensorStatuses] = useZibi("sensorStatuses");
  const [openQR, s_openQR] = useState(false);
  const [open_add_sensors_dialog, s_open_add_sensors_dialog] = useState(false);
  const [sensors, s_sensors] = useState([]);
  const [hover_sensor, s_hover_sensor] = useState(false);

  const [snackbarKey, setSnackbarKey] = useState(0); // Unique key for each message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [eventId, setEventId] = useState(null); // Store eventId separately

  const installerId = zibi.user.installerId;

  const getSensors = async () => {
    const res = await api({
      type: "getSensors",
      data: {
        edgeId,
        types: ["shelves", "shelves_weight"],
        fieldData: true,
      },
    });
    s_sensors(res);
  };

  const handleSnackbarClose = () => {
    setSnackbarMessage("");
    setEventId(null); // Reset eventId
    setSnackbarOpen(false);
  };

  const removeSensorFromEdge = async (sensorId) => {
    await api({ type: "removeSensorFromEdge", data: { edgeId, sensorId } });
    setSnackbarMessage("Sensor removed successfully!");
    setSnackbarOpen(true);
    getSensors();
  };

  const captureVideo = async (shelfId, boardId) => {
    console.log("captureVideo", shelfId);
    const eventId = await api({
      type: "debugCapture",
      data: { edgeId, shelfId, siteId, boardId },
    });

    console.log("eventId", eventId);
    setEventId(eventId.data.folder_name);

    // Update the Snackbar message and increment the snackbarKey for uniqueness
    setSnackbarMessage(`Video capture started! Event ID: ${eventId.eventId}`);
    setSnackbarKey((prevKey) => prevKey + 1); // Ensure unique key on each call
    setSnackbarOpen(true);

    getSensors();
  };

  const checkPlanogramBySensorId = async (sensorId, boardId) => {
    console.log("checkPlanogramBySensorId", sensorId);
    await api({
      type: "checkPlanogramBySensorId",
      data: { edgeId, sensorId, siteId, boardId },
    }).then(
      (res) => {
        setSnackbarMessage(
          `${res.deletedCount} planogram updated for : ${boardId}`
        );
        setSnackbarKey((prevKey) => prevKey + 1); // Ensure unique key on each call
        setSnackbarOpen(true);
      },
      (err) => console.log(err)
    );
  };
  const removeAlertsBySensorId = async (sensorId, boardId) => {
    console.log("removeAlertsBySensorId", sensorId);
    await api({
      type: "removeAlertsBySensorId",
      data: { edgeId, sensorId, siteId, boardId },
    }).then(
      (res) => {
        setSnackbarMessage(
          `${res.deletedCount} Alerts removed for : ${boardId}`
        );
        setSnackbarKey((prevKey) => prevKey + 1); // Ensure unique key on each call
        setSnackbarOpen(true);
      },
      (err) => console.log(err)
    );
  };

  const removePlacementsBySensorId = async (sensorId, boardId) => {
    console.log("removePlacementsBySensorId", sensorId);
    await api({
      type: "removePlacementsBySensorId",
      data: { edgeId, sensorId, siteId, boardId },
    }).then(
      (res) => {
        setSnackbarMessage(
          `  ${res.deletedCount} placements removed for : ${boardId}`
        );
        setSnackbarKey((prevKey) => prevKey + 1); // Ensure unique key on each call
        setSnackbarOpen(true);
      },
      (err) => console.log(err)
    );
  };

  const downloadPDF = async () => {
    const data = sensors.map((sensor) => ({
      sensorId: sensor._id,
      boardId: sensor.boardId,
    }));
    const linkSourceBase64 = await api({
      type: "downloadSensorsQRCodesPDF",
      data,
    });

    const [_, base64] = linkSourceBase64.split("data:application/pdf;base64,");
    try {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      const newWindow = window.open(url, "_blank");
      if (!newWindow) {
        alert("Please allow pop-ups for this site to view the PDF.");
      } else {
        setSnackbarMessage("PDF downloaded successfully!");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error opening blank PDF:", error);
      setSnackbarMessage("Error downloading PDF.");
      setSnackbarOpen(true);
    }
  };

  // Function to handle API call for debug download
  const handleDownloadDebug = async () => {
    const folderName = eventId;
    const url = `https://console.cloud.google.com/storage/browser/whatson_debug_capture/${folderName}`;

    window.open(url, "_blank");

    return;
    // try {
    //   const response = await api({
    //     type: "downloadDebugCapture",
    //     data: {
    //       eventId: folderName,
    //     },
    //   });

    //   if (!response.ok) throw new Error("Failed to download debug info");

    //   const blob = await response.blob();
    //   const url = URL.createObjectURL(blob);

    //   // Trigger download
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.download = `debug-info-${eventId}.zip`; // Assuming it's a PDF
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

    //   URL.revokeObjectURL(url); // Clean up the object URL
    // } catch (error) {
    //   console.error("Error downloading debug info:", error);
    //   setSnackbarMessage("Failed to download debug info. Try again.");
    // }
  };

  useEffect(() => {
    getSensors();
  }, [edgeId]);

  return (
    <Card
      // onClick={props.onClick}
      sx={{
        width: "100%",
        marginBottom: "5px",
        background: props.selected ? colors.LIGHT_GREEN + "50" : "white",
      }}
    >
      <div style={{ padding: 5 }}>
        <Icn style={{ position: "relative", top: 4 }}>sensor</Icn>{" "}
        <span style={{ fontSize: 18, fontWeight: 500 }}>
          <Tx>g.shelves</Tx> <small>({sensors.length})</small>
        </span>
        <div>
          {sensors.map((sensor) => {
            const sensorStatusData = sensorStatuses[sensor._id];
            const status = sensorStatusData?.status;
            const statusUpdateAt = sensorStatusData?.statusUpdateAt;
            return (
              <div
                onMouseEnter={() => s_hover_sensor(sensor._id)}
                onMouseLeave={() => s_hover_sensor(false)}
                key={sensor._id}
                style={{
                  position: "relative",
                  padding: 3,
                  minWidth: 100,
                  border: `1px solid ${colors.GREEN}`,
                  borderRadius: 3,
                  color: colors.GREEN,
                  fontWeight: "bold",
                  fontSize: 14,
                  margin: 2,
                  display: "inline-block",
                  textAlign: "center",
                }}
              >
                <SensorStatus status={status} statusUpdateAt={statusUpdateAt} />
                <ButtonGroup
                  size="small"
                  disableElevation
                  variant="text"
                  aria-label="actions for shelf "
                >
                  <Input value={sensor.boardId}> </Input>
                  {sensor.type === 3 && (
                    <span
                      style={{
                        color: colors.PINK,
                        position: "absolute",
                        fontSize: 11,
                        left: 1,
                        top: 0,
                      }}
                    >
                      W
                    </span>
                  )}

                  <Tooltip
                    title="Reload planogram for this sensor"
                    placement="top-start"
                  >
                    <Button>
                      <IconBtn
                        onClick={() =>
                          checkPlanogramBySensorId(sensor._id, sensor.boardId)
                        }
                        size="small"
                      >
                        nextPlanIcon
                      </IconBtn>
                    </Button>
                  </Tooltip>

                  <Tooltip
                    title="Remove alerts for this sensor"
                    placement="top-start"
                  >
                    <Button>
                      <IconBtn
                        onClick={() =>
                          removeAlertsBySensorId(sensor._id, sensor.boardId)
                        }
                        size="small"
                      >
                        autoDeleteIcon
                      </IconBtn>
                    </Button>
                  </Tooltip>

                  <Tooltip
                    title="Remove placements for this sensor"
                    placement="top"
                  >
                    <Button>
                      <IconBtn
                        onClick={() =>
                          removePlacementsBySensorId(sensor._id, sensor.boardId)
                        }
                        size="small"
                      >
                        signalCellularNodataIcon
                      </IconBtn>
                    </Button>
                  </Tooltip>

                  <Tooltip
                    title={
                      sensor.fieldData && sensor.fieldData.length > 0
                        ? "Capture video for this sensor"
                        : "No data available for video capture"
                    }
                    placement="top"
                  >
                    <Button
                      disabled={
                        sensor.fieldData && sensor.fieldData.length > 0
                          ? false
                          : true
                      }
                    >
                      <IconBtn
                        disabled={
                          sensor.fieldData && sensor.fieldData.length > 0
                            ? false
                            : true
                        }
                        onClick={() => captureVideo(sensor._id, sensor.boardId)}
                        size="small"
                      >
                        videoFileIcon
                      </IconBtn>
                    </Button>
                  </Tooltip>

                  <Tooltip
                    title="Remove this sensor from the edge"
                    placement="top-end"
                  >
                    <Button>
                      <IconBtn
                        onClick={() => removeSensorFromEdge(sensor._id)}
                        size="small"
                      >
                        delete
                      </IconBtn>
                    </Button>
                  </Tooltip>
                </ButtonGroup>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{ padding: 5 }}>
        <IconBtn
          customtheme="small-gray"
          size="small"
          onClick={() => s_open_add_sensors_dialog(true)}
        >
          add
        </IconBtn>
        <IconButton size={"normal"} onClick={downloadPDF}>
          <QRCode value="zibi" size={18} />
        </IconButton>
      </div>
      {open_add_sensors_dialog && (
        <InstallerAddSensorsToEdgeDialog
          types={["shelves", "shelves_weight"]}
          edgeId={edgeId}
          installerId={installerId}
          onClose={() => {
            s_open_add_sensors_dialog(false);
            getSensors();
          }}
        />
      )}

      {/* Snackbar component */}
      <Snackbar
        key={snackbarKey} // Unique key forces re-render
        open={snackbarOpen}
        autoHideDuration={14000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          action={
            eventId && ( // Only display the button if eventId exists
              <Button
                color="success"
                variant="contained"
                size="big"
                onClick={handleDownloadDebug} // Trigger API call
              >
                View files
              </Button>
            )
          }
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
}
